export default "__VITE_ASSET__B$gdQGGF__ 640w, __VITE_ASSET__B5NzQlNB__ 768w, __VITE_ASSET__CQwyjYUE__ 960w, __VITE_ASSET___lz5CJ0S__ 1280w";